module.exports = mf_shared;